var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.b(),style:(_vm.styleSizeName)},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasData),expression:"hasData"}],ref:_vm.id,style:(_vm.styleChartName)}),(!_vm.hasData)?[_c('avue-echart-empty')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }